
import Vue from 'vue';

import {Subscription} from 'rxjs';

import * as CorpusStore from '@/store/search/corpus';
import * as PatternStore from '@/store/search/form/patterns';
import * as FilterStore from '@/store/search/form/filters';

import { selectedSubCorpus$ } from '@/store/search/streams';

import * as BLTypes from '@/types/blacklabtypes';
import {ApiError} from '@/api';

import frac2Percent from '@/mixins/fractionalToPercent';
import { getValueFunctions, valueFunctions } from '@/components/filters/filterValueFunctions';

import Spinner from '@/components/Spinner.vue';
import { RecursiveRequired } from '@/types/helpers';

export default Vue.extend({
	components: {Spinner},
	data: () => ({
		subscriptions: [] as Subscription[],
		subCorpusStats: null as null|RecursiveRequired<BLTypes.BLDocResults>,
		error: null as null|ApiError,
	}),
	computed: {
		activeFilters: FilterStore.get.activeFilters,
		summaryMap(): Record<string, string> {
			const r: Record<string, string> = {};
			this.activeFilters.forEach(f => {
				const summary = getValueFunctions(f).luceneQuerySummary(f.id, f.metadata, f.value);
				if (summary) { r[f.id] = summary; }
			});
			return r;
		},

		matchingCount(): {
			documents: number;
			tokens: number;
		} {
			// If there's a source version, get the doc/token count from there.
			const source = PatternStore.get.shared().source;
			let count = null;
			if (source) {
				count = this.subCorpusStats?.summary.subcorpusSize?.annotatedFields?.find(f => f.fieldName === source) ?? null;
			}
			if (!count) {
				let documents = 0;
				let tokens = 0;
				this.subCorpusStats?.summary.subcorpusSize?.annotatedFields?.forEach(f => {
					documents += f.documents;
					tokens += f.tokens;
				});
				if (documents === 0 && tokens === 0) {
					// If no documents or tokens, use the total corpus size
					documents = this.subCorpusStats?.summary.numberOfDocs ?? 0;
					tokens = this.subCorpusStats?.summary.tokensInMatchingDocuments ?? 0;
				}
				count = {
					documents,
					tokens
				};
			}
			return count;
		},
		totalCorpusTokens(): number { return CorpusStore.getState().corpus!.tokenCount; },
		totalCorpusDocs(): number { return CorpusStore.getState().corpus!.documentCount; }
	},
	methods: {
		frac2Percent
	},
	created() {
		this.subscriptions.push(selectedSubCorpus$.subscribe(v => {
			this.subCorpusStats = v.value || null;
			this.error = v.error || null;
		}));
	},
	destroyed() {
		this.subscriptions.forEach(s => s.unsubscribe());
	}
});
